import { Select, Tag, Tooltip } from "@arco-design/web-react";
import { buildEnumOptions } from "@/enums/utils";
import { useEffect, useState } from "react";
import _ from "lodash";

export const EnumLabel = ({ enumObj, value }) => {
    if (value == null) return null;
    const entry = Object.values(enumObj).find(item => item.value === value);
    return entry ? entry.label : value;
};

export const EnumSelect = (props) => {
    const { value, enumObj, options, onChange, order, allowAll, ...restProps } = props;
    const [optionItems, setOptionItems] = useState([]);
    const [selectedValue, setSelectedValue] = useState(value);

    useEffect(() => {
        let items;
        if (enumObj) {
            items = buildEnumOptions(enumObj);
        } else if (options) {
            items = options;
        }
        if (order) {
            items = _.orderBy(items, [order], ['asc']);
        }
        if (allowAll) {
            items = [{ value: null, label: "All" }, ...items];
        }
        setOptionItems(items || []);
        setSelectedValue(value);
    }, [value, enumObj, options, order, allowAll])

    return (
        <Select {...restProps}
            defaultValue={selectedValue}
            value={selectedValue}
            options={optionItems}
            triggerProps={{
                autoAlignPopupWidth: false,
                autoAlignPopupMinWidth: true,
                position: 'bl',
            }}
            filterOption={(inputValue, option) => {
                return option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }}
            onChange={val => {
                setSelectedValue(val);
                onChange && onChange(val);
            }}
        />
    )
}

export const EnumMultiSelect = (props) => {
    const { value, enumObj, options, onChange, maxTagCount, ...restProps } = props;
    const [optionItems, setOptionItems] = useState([]);
    const [selectedValue, setSelectedValue] = useState(value);
    const [focus, setFocus] = useState(false);
    const [tagCount] = useState(maxTagCount ?? 2);

    useEffect(() => {
        let items;
        if (enumObj) {
            items = buildEnumOptions(enumObj);
        } else if (options) {
            items = options;
        }
        setOptionItems(items || []);
    }, [enumObj, options])

    useEffect(() => {
        setSelectedValue(value);
    }, [value])

    return (
        <EnumSelect {...restProps}
            value={selectedValue}
            mode="multiple"
            maxTagCount={tagCount}
            options={optionItems}
            renderTag={({ label, closable, onClose }, index) => {
                let tip = label;
                if (index >= 1) {
                    tip = _.slice(selectedValue, tagCount);
                    tip = _.join(_.map(tip, (item) => _.find(optionItems, (o) => o.value === item)?.label ?? item), ", ");
                }
                return (
                    <Tooltip mini
                        color="var(--color-primary-light-4)"
                        content={tip}>
                        <Tag
                            color={focus ? "gray" : "var(--color-white)"}
                            closable={closable}
                            onClose={onClose}
                            style={{ margin: '2px 6px 2px 0' }}>
                            <span style={{ color: "var(--color-text-2)" }}>{label}</span>
                        </Tag>
                    </Tooltip>
                )
            }}
            onFocus={(e) => {
                setFocus(true);
                props.onFocus && props.onFocus(e);
            }}
            onBlur={(e) => {
                setFocus(false);
                props.onBlur && props.onBlur(e);
            }}
            onChange={val => {
                setSelectedValue(val);
                onChange && onChange(val);
            }}
        />
    )
}
